const MmpMessagePlugin = {
  install: function (Vue) {
    let httpObj = window.vue.getInstance('http')
    var langCd = localStorage.getItem('language') || 'ko'
    var params = { systemCd: 'NRW', langCd: langCd }

    // NRW 메시지 및 텍스트 조회
    httpObj.b2c.selectTextList(this, params).then( (result) => {
      const data = result.data
      if ( data.status === 'OK' ) {
        let i18n = window.vue.getI18n()
        i18n.mergeLocaleMessage(langCd, data.data)
        console.log('MmpMessagePlugin init')
      }
    })
  }
}

export default MmpMessagePlugin



// WEBPACK FOOTER //
// ./src/plugins/_common/MmpMessage.js